import { CLICK, component, demoFile, story } from 'system/demo';
import { NotificationPermissionWidget } from 'open-modules/zdf/feature/account/account-notification-permission';

demoFile('open-modules/zdf/feature/account/account-notification-permission');

component('NotificationPermissionWidget', NotificationPermissionWidget, {
    structureKey: 'account',
    features: [
        'notificationpermission',
        'pushnotificationpermission',
        'emailnotificationpermission',
    ]
}, [
    story('Toggle push notifications', [CLICK('Push notifications')]),
    story('Toggle email notifications', [CLICK('Email notifications')])
]);
